import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';

/** Report key the Static - Input Values screen uses for its years. */
export const STATIC_VALUES_REPORT = 'static-values';

/**
 * Looks up the reinsurance years held in a report's table, via
 * `GET ReinsuranceYears/GetReinsuranceYears?report=<key>`, to fill the
 * Reinsurance Year dropdowns.
 *
 * `report` is the report's key (its route slug, e.g. `summary`, `sop`), or
 * {@link STATIC_VALUES_REPORT}. The API maps each key to its table.
 */
@Injectable({ providedIn: 'root' })
export class ReinsuranceYearsService {
  /** apiBaseUrl without any trailing slash. */
  private readonly base = environment.apiBaseUrl.replace(/\/+$/, '');

  constructor(private readonly http: HttpClient) {}

  /** The distinct years in the report's table, newest first. */
  getYears(report: string): Observable<number[]> {
    const url = `${this.base}/ReinsuranceYears/GetReinsuranceYears?report=${encodeURIComponent(report)}`;
    return this.http.get<number[]>(url).pipe(map((years) => years ?? []));
  }
}
